/* ========================================================================
   tp-cross-sell.js
   ------------------------------------------------------------------------
   [2026-07-03] Aus sections/tp-cross-sell.liquid ausgelagert (Refactoring
   Stufe 2 / TP-19, JS-Welle A). Vorher Inline-IIFE mit Liquid-Interpolation
   ({{ section.id }}, max_products). Jetzt cachebar/CSP-freundlich, defer
   geladen; liest max_products aus data-max-products. Initialisiert alle
   .tp-cs[data-skus]-Sektionen der Seite (Customizer-Reload-sicher via
   data-tp-cs-initialized-Guard).
   ======================================================================== */
(function () {
  'use strict';

  /* Shopify-CDN-Bilder in Kartengröße laden statt in Originalgröße */
  function sizedImage(url) {
    if (!url || url.indexOf('cdn.shopify.com') === -1 || /[?&]width=/.test(url)) return url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=400';
  }

  function initSection(section) {
    if (section.getAttribute('data-tp-cs-initialized') === 'true') return;
    section.setAttribute('data-tp-cs-initialized', 'true');

                  if (!section) return;

          var skus = (section.getAttribute('data-skus') || '').split(',').filter(Boolean);
          var productUrl = section.getAttribute('data-product-url') || '';
          var filesBase = section.getAttribute('data-files-base') || '';
          var cacheVersion = section.getAttribute('data-version') || '1';
          var maxProducts = parseInt(section.getAttribute('data-max-products') || '12', 10) || 12;

          var scrollEl = section.querySelector('[data-tp-cs-scroll]');
          var prevBtn = section.querySelector('[data-tp-cs-prev]');
          var nextBtn = section.querySelector('[data-tp-cs-next]');

          if (!skus.length || !filesBase || !scrollEl) return;

          var CACHE_TTL = 3600000;
          var CACHE_PREFIX = 'tp_cs_v' + cacheVersion + '_';

          function hideSection() {
            section.style.display = 'none';
          }

          function withVersion(url) {
            return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'v=' + encodeURIComponent(cacheVersion);
          }

          function cacheGet(key) {
            try {
              var raw = sessionStorage.getItem(CACHE_PREFIX + key);
              if (!raw) return null;

              var obj = JSON.parse(raw);
              if (!obj || Date.now() - obj.ts > CACHE_TTL) {
                sessionStorage.removeItem(CACHE_PREFIX + key);
                return null;
              }

              return obj.d;
            } catch (e) {
              return null;
            }
          }

          function cacheSet(key, data) {
            try {
              sessionStorage.setItem(
                CACHE_PREFIX + key,
                JSON.stringify({
                  ts: Date.now(),
                  d: data,
                })
              );
            } catch (e) {}
          }

          function fetchJSON(url, cacheKey) {
            var cached = cacheGet(cacheKey);
            if (cached) return Promise.resolve(cached);

            return fetch(withVersion(url))
              .then(function (response) {
                if (!response.ok) throw new Error(response.status);
                return response.json();
              })
              .then(function (data) {
                cacheSet(cacheKey, data);
                return data;
              });
          }

          function esc(value) {
            var el = document.createElement('span');
            el.textContent = value == null ? '' : String(value);
            return el.innerHTML.replace(/"/g, '&quot;').replace(/'/g, '&#39;');
          }

          function fmtPrice(value) {
            var number = Number(value);
            if (!isFinite(number)) return '';
            return number.toFixed(2).replace('.', ',') + '\u200a\u20ac';
          }

          function renderCard(product) {
            var badge = '';
            var productTitle = esc(product.t);
            var linkLabel = 'Produkt ansehen: ' + productTitle;

            if (product.tp === 'K') {
              badge = '<span class="tp-cs-badge tp-cs-badge--k">Kompatibel</span>';
            } else if (product.tp === 'O') {
              badge = '<span class="tp-cs-badge tp-cs-badge--o">Original</span>';
            }

            var image = product.im
              ? '<img src="' +
                esc(sizedImage(product.im)) +
                '" alt="' +
                productTitle +
                '" loading="lazy" width="200" height="160">'
              : '';

            return (
              '<a href="' +
              esc(product.u) +
              '" class="tp-cs-card" role="listitem" aria-label="' +
              linkLabel +
              '">' +
              '<div class="tp-cs-card-img">' +
              badge +
              image +
              '</div>' +
              '<div class="tp-cs-card-body">' +
              '<div class="tp-cs-title">' +
              productTitle +
              '</div>' +
              '<div class="tp-cs-bottom">' +
              '<span class="tp-cs-price">' +
              fmtPrice(product.pr) +
              '</span>' +
              '<span class="tp-product-btn"><span>Zum Produkt</span>' +
              '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 12h14M12 5l7 7-7 7"/></svg>' +
              '</span>' +
              '</div>' +
              '</div>' +
              '</a>'
            );
          }

          function updateNavState() {
            if (!prevBtn || !nextBtn) return;

            var maxScroll = scrollEl.scrollWidth - scrollEl.clientWidth;
            var position = scrollEl.scrollLeft;

            prevBtn.disabled = position <= 2;
            nextBtn.disabled = position >= maxScroll - 2;
          }

          function scrollByCards(direction) {
            var firstCard = scrollEl.querySelector('.tp-cs-card');
            if (!firstCard) return;

            var step = (firstCard.offsetWidth + 16) * 2;
            scrollEl.scrollBy({
              left: direction * step,
              behavior: 'smooth',
            });
          }

          function initNav() {
            if (!prevBtn || !nextBtn) return;

            prevBtn.addEventListener('click', function () {
              scrollByCards(-1);
            });

            nextBtn.addEventListener('click', function () {
              scrollByCards(1);
            });

            scrollEl.addEventListener('scroll', updateNavState, { passive: true });
            window.addEventListener('resize', updateNavState);

            setTimeout(updateNavState, 50);
          }

          function updateLivePrices() {
            var cards = scrollEl.querySelectorAll('.tp-cs-card');
            var items = [];

            cards.forEach(function (card) {
              var href = card.getAttribute('href');
              if (!href) return;

              items.push({
                el: card,
                handle: href.replace(/^\/products\//, '').split('?')[0],
              });
            });

            var index = 0;

            function nextBatch() {
              if (index >= items.length) return;

              var batch = items.slice(index, index + 6);
              index += 6;

              Promise.all(
                batch.map(function (item) {
                  return fetch('/products/' + encodeURIComponent(item.handle) + '.js')
                    .then(function (response) {
                      return response.ok ? response.json() : null;
                    })
                    .then(function (data) {
                      if (!data) return;

                      var priceEl = item.el.querySelector('.tp-cs-price');
                      if (priceEl) {
                        priceEl.textContent = fmtPrice(parseInt(data.price, 10) / 100);
                      }

                      if (!data.available) {
                        item.el.classList.add('tp-cs-card--oos');

                        var ctaEl = item.el.querySelector('.tp-product-btn');
                        if (ctaEl) ctaEl.classList.add('tp-product-btn--unavailable');

                        var imageWrap = item.el.querySelector('.tp-cs-card-img');
                        if (imageWrap && !imageWrap.querySelector('.tp-cs-badge--oos')) {
                          imageWrap.insertAdjacentHTML(
                            'beforeend',
                            '<span class="tp-cs-badge tp-cs-badge--oos">Ausverkauft</span>'
                          );
                        }
                      }
                    })
                    .catch(function () {});
                })
              ).then(function () {
                setTimeout(nextBatch, 150);
              });
            }

            nextBatch();
          }

          function init() {
            fetchJSON(filesBase + 'cross-sell-sku.json', 'sku')
              .then(function (skuMap) {
                var match = null;

                for (var i = 0; i < skus.length; i++) {
                  if (skuMap[skus[i]]) {
                    match = skuMap[skus[i]];
                    break;
                  }
                }

                if (!match) {
                  hideSection();
                  return null;
                }

                var firstPipe = match.indexOf('|');
                if (firstPipe < 1) {
                  hideSection();
                  return null;
                }

                var chunkFile = match.substring(0, firstPipe) + '.json';
                var printerKey = match.substring(firstPipe + 1);

                return fetchJSON(filesBase + chunkFile, 'chunk_' + chunkFile).then(function (chunkData) {
                  var products = chunkData[printerKey];

                  if (!products || !products.length) {
                    hideSection();
                    return;
                  }

                  var compatible = [];
                  var original = [];
                  var seen = {};

                  products.forEach(function (item) {
                    if (!item || !item.u) return;
                    if (item.u === productUrl || seen[item.u]) return;

                    seen[item.u] = true;

                    if (item.tp === 'K') {
                      compatible.push(item);
                    } else {
                      original.push(item);
                    }
                  });

                  var items = compatible.concat(original).slice(0, maxProducts);

                  if (!items.length) {
                    hideSection();
                    return;
                  }

                  scrollEl.innerHTML = items.map(renderCard).join('');
                  section.style.display = 'block';

                  initNav();
                  updateLivePrices();
                });
              })
              .catch(hideSection);
          }

          init();
  }

  function boot() {
    document.querySelectorAll('.tp-cs[data-skus]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Customizer: neu gerenderte Section initialisieren.
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector ? e.target.querySelector('.tp-cs[data-skus]') : null;
    if (el) initSection(el);
  });
})();
